export default "__VITE_ASSET__Dl_oXKvn__"